module.exports = __webpack_public_path__ + "img/litecoin.6046cca1.svg";